const getVariant = (v, i) => {
  return (
    v.storefrontId === i.id ||
    v.id === i.id ||
    v.sku?.toUpperCase() === i.sku?.toUpperCase()
  );
};

export default getVariant;
